import { render, staticRenderFns } from "./VistaPesajes.vue?vue&type=template&id=1264b404&"
import script from "./VistaPesajes.vue?vue&type=script&lang=ts&"
export * from "./VistaPesajes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports